// For entries flagged `showPopupOncePerDevice`: which of them this browser has
// already shown, independent of who is logged in.
const seenStorageKey = (slug: string) => `julo-update-popup-seen:${slug}`

export const hasSeenPopupOnDevice = (slug: string): boolean => {
  try {
    return localStorage.getItem(seenStorageKey(slug)) !== null
  } catch {
    // Storage that can't be read would pop up on every load otherwise
    return true
  }
}

export const markPopupSeenOnDevice = (slug: string): void => {
  try {
    localStorage.setItem(seenStorageKey(slug), new Date().toISOString())
  } catch (error) {
    console.error("Failed to store Julo Update popup state:", error)
  }
}

export const devicePopupSeenStorageKey = seenStorageKey
